<template>
<div>
  <div v-if="passwordChanged">
    Your password has been changed successfully.  Please sign in <router-link to="/">here.</router-link>
  </div>
  <div v-else-if="codeSent">
    <h1>Forgot Password</h1>
    <div class="container text-left">
      <div class="row justify-content-md-center">
        <div class="col-lg-5">
          <p>We have sent a code to your email on file, please check that code and enter it here along with your new password in order to change it.</p>
          <br>
          <form @submit.prevent="confirmCodeAndChangePassword">
              <b-form-group :invalid-feedback="invalidCode" :state="state" label="Confirmation Code" label-for="code">
                  <b-form-input id="code" v-model="code" type="text" :state="codeSubmitted && $v.code.$error ? false : null" />
                  <b-form-invalid-feedback v-if="codeSubmitted && !$v.code.required">The confirmation code is required</b-form-invalid-feedback>
                  <b-form-invalid-feedback :state="state"></b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="New Password" label-for="password">
                  <b-form-input id="password" name="password" v-model="password" type="password" autocomplete="new-password" :state="codeSubmitted && $v.password.$error ? false : null" />
                  <b-form-invalid-feedback v-if="codeSubmitted && !$v.password.required">Password is required</b-form-invalid-feedback>
                  <b-form-invalid-feedback v-if="codeSubmitted && !$v.password.minLength">Password needs to be at least 10 characters</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Confirm New Password" label-for="confirmPassword">
                  <b-form-input id="confirmPassword" name="confirmPassword" v-model="confirmPassword" type="password" autocomplete="new-password" :state="codeSubmitted && $v.confirmPassword.$error ? false : null" />
                  <b-form-invalid-feedback v-if="codeSubmitted && !$v.confirmPassword.required">Confirm Password is required</b-form-invalid-feedback>
                  <b-form-invalid-feedback v-if="codeSubmitted && !$v.confirmPassword.sameAs">Confirm Password needs to be the same as the password entered above</b-form-invalid-feedback>
                  <b-form-invalid-feedback v-if="codeSubmitted && !$v.confirmPassword.minLength">Confirm Password needs to be at least 10 characters</b-form-invalid-feedback>
              </b-form-group>

              <b-button type=submit :disabled="codeSubmitted && $v.$invalid">Change Password</b-button>

              <b-form-invalid-feedback v-if="codeSubmitted && !$v.$invalid">{{ errorMsg }}</b-form-invalid-feedback>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
  <h1>Forgot Password</h1>

    <div class="container text-left">
      <div class="row justify-content-md-center">
        <div class="col-lg-5">
        <p>We all forget our password sometimes. Enter your email<br> address below so we can help you reset your password.</p><br>
          <form @submit.prevent="resendPassword">
            <b-form-group label="Email Address" label-for="email">
              <b-form-input id="email" v-model="email"  type="text" @click="clearErrors()" :state="submitted && $v.email.$error ? false : null" />
              <b-form-invalid-feedback v-if="submitted && !$v.email.required">Email is required</b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="submitted && !$v.email.email">Email needs to be a valid email</b-form-invalid-feedback>
            </b-form-group>
            <span v-if="errorMsg !== null" class="text-danger">
              <span v-html="errorMsg"></span>
            </span>
            <b-button type=submit :disabled="submitted && $v.email.$error">Reset Password</b-button>

            <b-form-invalid-feedback v-if="submitted && !$v.email.$error">{{ errorMsg }}</b-form-invalid-feedback>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  required, email, minLength, sameAs,
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      email: '',
      code: '',
      codeReceived: false,
      password: '',
      confirmPassword: '',
      codeSent: false,
      passwordChanged: false,
      submitted: false,
      codeSubmitted: false,
      errorMsg: '',
      error: '',
      codeReceivedErrorMessage: 'Invalid verification code provided, please try again.',
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    code: {
      required,
    },
    password: {
      required,
      minLength: minLength(10),
    },
    confirmPassword: {
      required,
      sameAs: sameAs('password'),
      minLength: minLength(10),
      codeReceived: false,
    },
  },
  computed: {
    state() {
      return this.codeReceived === false;
    },
    invalidCode() {
      if (this.codeReceived) {
        return this.codeReceivedErrorMessage;
      }
      return null;
    },
  },
  methods: {
    resendPassword() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.email.$error) {
        return;
      }

      this.$store.dispatch('auth/forgotPassword', {
        username: this.email.toLowerCase(),
      }).then(() => {
        this.codeSent = true;
      }).catch((err) => {
        this.error = err;
        this.errorMsg = 'Email address not found.<br>';
      });
    },
    confirmCodeAndChangePassword() {
      this.codeSubmitted = true;
      this.$v.$touch();
      if (this.$v.invalid) {
        return;
      }

      this.$store.dispatch('auth/confirmPassword', {
        username: this.email.toLowerCase(),
        code: this.code,
        newPassword: this.password,
      }).then(() => {
        this.passwordChanged = true;
      }).catch((err) => {
        this.errorMsg = err.message;
        this.codeReceived = true;
      });
    },
    clearErrors() {
      this.errorMsg = '';
      this.codeReceived = false;
    },
  },
};
</script>

<style scoped>
div >>> .d-block {
  font-weight: 700;
}

</style>
